import { PAGE_PARAM } from 'academy-common-lib/features/pagination/paginationConsts';
// @ts-expect-error Could not find a declaration file for module
import { useSearchParam } from 'academy-common-lib/hooks/searchParamHooks';
export const usePagination = () => {
  const [[currentPageParam], setCurrentPageParam] = useSearchParam(PAGE_PARAM);
  const currentPage = Number(currentPageParam) || 1;
  const setPage = page => {
    if (!page || page === currentPage) return;
    setCurrentPageParam(`${page}`);
  };
  return {
    currentPage,
    setPage
  };
};